/**
 * file : datas.js
 * 설명 : 공통 데이터 모음
 */

/**
 * URL 참 거짓 여부 (true: 서버, false: 로컬)
 */
const URLBoolean = true;
/**
 * API 경로
 * true: 서버, false: 로컬
 */
let ApiUrl = '';
if (URLBoolean) {
    ApiUrl = 'http://api.tmt.casino';
} else {
    ApiUrl = 'http://localhost:8000';
}
/**
 * 실시간 URL
 * true: 서버, false: 로컬
 */
let RealTimeUrl = '';
if (URLBoolean) {
    RealTimeUrl = 'http://real-time.tmt.casino';
} else {
    RealTimeUrl = 'http://localhost:7447';
}

// ========================== 이미지 경로 ==========================
const TournamentImgUrl = `${ApiUrl}/storage/tournament_images/`
const BoardImgUrl = `${ApiUrl}/storage/board/`

export { ApiUrl, RealTimeUrl, BoardImgUrl, TournamentImgUrl }